import React from 'react';
import './HeroSection.css'
const HeroSection = () => {
    return (
        <div className='lg:pt-48 pt-16'>
         
            <section class="text-gray-600 body-font   ">
         
                <div class="container  mx-auto flex px-5 lg:py-24 py-12 items-center justify-center flex-col">
                    <div class="text-left text-center lg:w-2/3 w-full">
                     
                        <p class="leading-relaxed text-white body font-light text-xm ">Hello This is</p>
                        <h1 className='font-bold mb-6 text-white title-font lg:text-6xl text-4xl '>Foyjur Rahman,</h1>
                        <h2 className='font-bold body lg:text-5xl text-4xl  mb-5 gradient'>I'm Full stack web Developer.<br/></h2>
                        <p className='text-white text-lg mt-8 lg:px-32 px-3'>I'm passionate to building amazing user interface & User experience Product for easier human daily life.I believe Creative idea and product can make human life comfortable and effortless.As a junior Full stack web developer I focus on learning new technologies and tools to boost my working experience. </p>
                        <div class="flex justify-center mt-5">
                            <button class="btn bg shadow   mt-5"><a className='text-white text-lg ' href='https://www.linkedin.com/in/foyjur-rahman-164201112/' target="_blank" rel='noopener noreferrer'>Do you want to work with me ??</a> </button>
                       
                        </div>
                    </div>
                </div>
            </section>
            
        </div>
    );
};

export default HeroSection;